// This file has been automatically generated.

export const serviceAshby = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#453AC5" />
      <path
        d="M15.017 14.576c.144.361.3.633.466.814.178.169.35.26.517.271V16c-.8-.034-1.81-.051-3.033-.051-1.267 0-2.2.017-2.8.051v-.339c.422-.023.722-.074.9-.153.177-.09.266-.242.266-.457 0-.204-.066-.475-.2-.814l-.983-2.78H6.782l-.283.763c-.367.96-.55 1.695-.55 2.203 0 .464.127.78.383.95.256.17.634.265 1.134.288V16a54.639 54.639 0 0 0-2.184-.051c-.522 0-.95.017-1.283.051v-.339c.277-.045.538-.22.783-.526.245-.305.494-.79.75-1.457L9.233 4c.356.023.65.034.884.034.222 0 .51-.011.866-.034l4.034 10.576Zm-4.983-3.457L8.515 6.88l-1.6 4.238h3.117Z"
        fill="#fff"
      />
    </>
  ),
  size: 20,
};

export const serviceCalendly = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#2B6AF6" />
      <g fill="#fff" clipPath="url(#a)">
        <path d="m12.597 12.117-.001.001c-.453.402-1.019.902-2.044.902h-.614c-.742 0-1.417-.27-1.9-.758a2.595 2.595 0 0 1-.732-1.842v-.84a2.594 2.594 0 0 1 .732-1.84c.483-.49 1.158-.759 1.9-.759h.614c1.027 0 1.59.5 2.044.902l.006.005c.468.413.874.771 1.951.771.165 0 .33-.013.493-.039l-.004-.01a3.683 3.683 0 0 0-.227-.467l-.723-1.253a3.716 3.716 0 0 0-3.217-1.857H9.43A3.715 3.715 0 0 0 6.21 6.89l-.723 1.253a3.717 3.717 0 0 0 0 3.715l.723 1.252a3.715 3.715 0 0 0 3.218 1.857h1.446a3.715 3.715 0 0 0 3.217-1.857l.723-1.25c.087-.15.163-.307.227-.468l.004-.008a2.99 2.99 0 0 0-.492-.042c-1.081 0-1.487.36-1.957.775Z" />
        <path d="M15.256 10.646a3.467 3.467 0 0 1 1.427.613c.407.301.328.641.267.843a7.133 7.133 0 1 1 0-4.203c.061.201.14.542-.267.843a3.47 3.47 0 0 1-1.427.613v-.011a3.741 3.741 0 0 0-.207-.724 2.715 2.715 0 0 0 1.18-.486 6.363 6.363 0 1 0 0 3.733 2.72 2.72 0 0 0-1.18-.486c.093-.234.162-.476.207-.723v-.012Z" />
        <path d="M9.939 7.742h.613c.738 0 1.119.337 1.54.71.515.457 1.09.968 2.461.968.236 0 .471-.022.703-.065.075.427.075.864 0 1.29a3.786 3.786 0 0 0-.703-.064c-1.37 0-1.945.51-2.462.968-.42.373-.8.71-1.54.71H9.94c-1.13 0-1.872-.806-1.872-1.839v-.839c0-1.033.742-1.84 1.872-1.84Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            transform="translate(3 2.866)"
            d="M0 0h14v14.268H0z"
          />
        </clipPath>
      </defs>
    </>
  ),
  size: 20,
};

export const serviceCoderpad = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#CC4E41" />
      <path
        d="m4.532 10.24 2.996 1.017v1.418L3 10.828V9.632l4.528-1.847v1.418L4.532 10.24ZM9.258 14h-1.13l2.818-8h1.13l-2.818 8Zm6.216-3.775-3.055-1.027V7.79L17 9.637v1.19l-4.582 1.852v-1.412l3.056-1.042Z"
        fill="#fff"
      />
    </>
  ),
  size: 20,
};

export const serviceCodesignal = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#004AE1" />
      <g clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd">
        <path
          d="m9.979 7.103-.155-.695L3 5.5l2.19 3.153.45.053 1.151 1.777 1.04.12 2.19 4.864 2.134-4.864 1.068-.08 1.151-1.817.393-.053L17 5.5l-6.838.908-.183.695Z"
          fill="#fff"
        />
        <path
          d="M8.927 7.291 5.02 6.622l.787 1.151 2.304.295.224.75-1.517-.135.59.937 1.223.094 1.404 3.962 1.391-3.962 1.236-.094.59-.937-1.517.134.225-.75 2.304-.294.8-1.15-3.947.668-1.096 3.962-1.095-3.962Z"
          fill="#004AE1"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(3 5.5)" d="M0 0h14v10H0z" />
        </clipPath>
      </defs>
    </>
  ),
  size: 20,
};

export const serviceDribbble = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#EA4C89" />
      <path
        d="M7.673 5.17a5.395 5.395 0 0 1 2.369-.545c.935 0 1.816.237 2.584.655-.541.608-1.281 1.31-2.221 1.917A18.7 18.7 0 0 0 7.673 5.17Zm3.654 2.914a12.385 12.385 0 0 0 2.326-2.08 5.423 5.423 0 0 1 1.512 2.275c-1.015.31-1.882.725-2.623 1.2a17.537 17.537 0 0 0-1.215-1.395Zm.209 2.138a16.328 16.328 0 0 0-1.31-1.474A10.105 10.105 0 0 1 4.627 9.88a5.419 5.419 0 0 0 3.815 5.339A9.786 9.786 0 0 1 9.5 12.641a9.435 9.435 0 0 1 2.036-2.42Zm-1.862 5.224a8.54 8.54 0 0 1 .903-2.17 8.177 8.177 0 0 1 1.694-2.038 16.082 16.082 0 0 1 1.47 2.76 5.398 5.398 0 0 1-4.067 1.448Zm3.603-4.953a9.283 9.283 0 0 1 2.155-.988 5.39 5.39 0 0 1-.799 3.41 17.27 17.27 0 0 0-1.356-2.422ZM6.623 6c.796.457 1.702 1.061 2.618 1.84a8.885 8.885 0 0 1-4.433.8A5.418 5.418 0 0 1 6.52 5.926.628.628 0 0 0 6.623 6Zm3.419-2.625a6.667 6.667 0 1 0 0 13.333 6.667 6.667 0 0 0 0-13.333Z"
        fill="#fff"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </>
  ),
  size: 20,
};

export const serviceFigma = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#000" />
      <g clipPath="url(#a)">
        <path
          d="M10 10c0-.575.21-1.126.586-1.532A1.925 1.925 0 0 1 12 7.833c.53 0 1.04.228 1.414.635.375.406.586.957.586 1.532 0 .574-.21 1.125-.586 1.532a1.925 1.925 0 0 1-1.414.634c-.53 0-1.04-.228-1.414-.634A2.261 2.261 0 0 1 10 10Z"
          fill="#1ABCFE"
        />
        <path
          d="M6 14.334c0-.575.21-1.126.586-1.532A1.925 1.925 0 0 1 8 12.167h2v2.167c0 .574-.21 1.125-.586 1.532A1.925 1.925 0 0 1 8 16.5c-.53 0-1.04-.228-1.414-.634A2.261 2.261 0 0 1 6 14.334Z"
          fill="#0ACF83"
        />
        <path
          d="M10 3.5v4.333h2c.53 0 1.04-.228 1.414-.634.375-.407.586-.958.586-1.532 0-.575-.21-1.126-.586-1.532A1.925 1.925 0 0 0 12 3.5h-2Z"
          fill="#FF7262"
        />
        <path
          d="M6 5.667c0 .574.21 1.125.586 1.532.375.406.884.634 1.414.634h2V3.5H8c-.53 0-1.04.228-1.414.635A2.262 2.262 0 0 0 6 5.667Z"
          fill="#F24E1E"
        />
        <path
          d="M6 10c0 .574.21 1.125.586 1.532.375.406.884.634 1.414.634h2V7.833H8c-.53 0-1.04.228-1.414.635A2.262 2.262 0 0 0 6 10Z"
          fill="#A259FF"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(6 3.5)" d="M0 0h8v13H0z" />
        </clipPath>
      </defs>
    </>
  ),
  size: 20,
};

export const serviceGithub = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#000" />
      <path
        d="M10 3c-1.663 0-3.27.607-4.537 1.712A7.224 7.224 0 0 0 3.09 9.029a7.33 7.33 0 0 0 .921 4.865 7.036 7.036 0 0 0 3.776 3.094c.35.066.478-.156.478-.346 0-.17-.006-.622-.01-1.221-1.946.434-2.357-.962-2.357-.962a1.896 1.896 0 0 0-.777-1.05c-.636-.445.048-.436.048-.436.221.031.433.114.62.242.185.129.34.299.452.497.095.178.223.334.377.46a1.476 1.476 0 0 0 1.103.323c.196-.024.385-.087.557-.186a1.55 1.55 0 0 1 .444-.96c-1.554-.18-3.188-.797-3.188-3.547a2.814 2.814 0 0 1 .72-1.926 2.642 2.642 0 0 1 .069-1.9s.588-.192 1.925.736a6.477 6.477 0 0 1 3.505 0c1.336-.928 1.923-.735 1.923-.735.258.6.283 1.28.07 1.9a2.81 2.81 0 0 1 .72 1.925c0 2.757-1.637 3.364-3.197 3.542.167.174.296.382.378.612.082.229.115.473.097.717 0 .96-.008 1.733-.008 1.969 0 .192.126.415.481.345a7.036 7.036 0 0 0 3.774-3.096 7.331 7.331 0 0 0 .918-4.864 7.225 7.225 0 0 0-2.374-4.316A6.899 6.899 0 0 0 10 3Z"
        fill="#fff"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </>
  ),
  size: 20,
};

export const serviceGitlab = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#380D76" />
      <path d="m10 16 2.393-7.382H7.606L10 16Z" fill="#E24329" />
      <path d="M10 16 7.606 8.618H4.252L10 16Z" fill="#FC6D26" />
      <path
        d="m4.252 8.618-.728 2.243a.497.497 0 0 0 .18.555L10 16 4.252 8.618Z"
        fill="#FCA326"
      />
      <path
        d="M4.252 8.618h3.354L6.165 4.172a.248.248 0 0 0-.472 0L4.252 8.618Z"
        fill="#E24329"
      />
      <path d="m10 16 2.394-7.382h3.354L10 16Z" fill="#FC6D26" />
      <path
        d="m15.748 8.618.728 2.243a.497.497 0 0 1-.18.555L10 16l5.748-7.382Z"
        fill="#FCA326"
      />
      <path
        d="M15.748 8.618h-3.354l1.441-4.446a.248.248 0 0 1 .471 0l1.442 4.446Z"
        fill="#E24329"
      />
    </>
  ),
  size: 20,
};

export const serviceGoodtime = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#4C36A5" />
      <path
        d="M10 16V4a6 6 0 1 0 0 12Z"
        fill="#fff"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path d="M11 16h5v-5a5 5 0 0 0-5 5Z" fill="#fff" />
      <circle cx="13.5" cy="6.5" r="2.5" fill="#32D0AE" />
    </>
  ),
  size: 20,
};

export const serviceGoogle = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#F0F3F5" />
      <path
        d="M10.068 5.659c1.12-.07 2.17.35 3.009 1.12l1.82-1.89C13.566 3.63 11.816 3 10.066 3 7.41 3 5.03 4.4 3.77 6.709l2.1 1.679a4.314 4.314 0 0 1 4.198-2.729Z"
        fill="#E94435"
      />
      <path
        d="M5.66 9.998c0-.56.07-1.12.28-1.61L3.84 6.71c-.56.98-.84 2.17-.84 3.289 0 1.12.28 2.309.77 3.289l2.17-1.68c-.21-.49-.28-1.05-.28-1.61Z"
        fill="#F8BB15"
      />
      <path
        d="M12.657 13.706c-.84.42-1.75.7-2.66.63-1.819 0-3.428-1.05-4.058-2.73l-2.17 1.68c1.26 2.309 3.64 3.778 6.229 3.708 1.75.07 3.429-.56 4.758-1.609l-2.099-1.68Z"
        fill="#34A751"
      />
      <path
        d="M16.996 9.997c0-.49-.07-.91-.14-1.4H9.998v2.8h4.269v.14c-.21.91-.77 1.679-1.54 2.169l2.1 1.68c1.469-1.4 2.239-3.36 2.169-5.389Z"
        fill="#547DBE"
      />
    </>
  ),
  size: 20,
};

export const serviceGoogleMeet = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#F0F3F5" />
      <path
        d="m10.92 10 1.365 1.557 1.835 1.171.32-2.718-.32-2.657-1.87 1.028L10.92 10Z"
        fill="#00832D"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M3 12.475v2.316c0 .53.43.959.96.959h2.32l.48-1.751-.48-1.524-1.592-.479-1.688.48Z"
        fill="#0066DA"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M6.28 4.25 3 7.524l1.688.48 1.592-.48.472-1.503L6.28 4.25Z"
        fill="#E94235"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M3 12.476h3.28V7.524H3v4.952Z"
        fill="#2684FC"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M16.215 5.636 14.12 7.352v5.376l2.104 1.722a.48.48 0 0 0 .776-.377V6.006a.48.48 0 0 0-.785-.371Z"
        fill="#00AC47"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M10.92 10v2.476H6.28v3.274h6.88c.53 0 .96-.429.96-.958v-2.064L10.92 10Z"
        fill="#00AC47"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M13.16 4.25H6.28v3.274h4.64V10l3.2-2.647V5.208c0-.53-.43-.958-.96-.958Z"
        fill="#FFBA00"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </>
  ),
  size: 20,
};

export const serviceGreenhouse = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#008561" />
      <path
        d="M12.241 7.565c0 .58-.256 1.092-.676 1.493-.468.446-1.145.557-1.145.936 0 .513.864.356 1.693 1.148.549.524.887 1.215.887 2.017C13 14.74 11.67 16 10 16s-3-1.258-3-2.84c0-.803.339-1.494.887-2.017.829-.792 1.693-.635 1.693-1.148 0-.379-.677-.49-1.144-.936-.42-.401-.677-.914-.677-1.516 0-1.158.992-2.094 2.206-2.094.234 0 .444.033.619.033.315 0 .479-.133.479-.345 0-.123-.06-.279-.06-.446 0-.379.34-.691.748-.691.409 0 .736.323.736.713 0 .412-.339.602-.596.691-.21.067-.373.156-.373.357 0 .377.723.745.723 1.804Zm-.232 5.595A1.971 1.971 0 0 0 10 11.165a1.971 1.971 0 0 0-2.008 1.995c0 1.092.852 1.995 2.008 1.995a1.979 1.979 0 0 0 2.008-1.995Zm-.69-5.618c0-.701-.595-1.281-1.319-1.281-.723 0-1.319.58-1.319 1.281 0 .702.596 1.282 1.319 1.282.724 0 1.32-.58 1.32-1.282Z"
        fill="#fff"
      />
    </>
  ),
  size: 20,
};

export const serviceGreenhouseDisabled = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#AFB8BF" />
      <path
        d="M12.241 7.565c0 .58-.256 1.092-.676 1.493-.468.446-1.145.557-1.145.936 0 .513.864.356 1.693 1.148.549.524.887 1.215.887 2.017C13 14.74 11.67 16 10 16s-3-1.258-3-2.84c0-.803.339-1.494.887-2.017.829-.792 1.693-.635 1.693-1.148 0-.379-.677-.49-1.144-.936-.42-.401-.677-.914-.677-1.516 0-1.158.992-2.094 2.206-2.094.234 0 .444.033.619.033.315 0 .479-.133.479-.345 0-.123-.06-.279-.06-.446 0-.379.34-.691.748-.691.409 0 .736.323.736.713 0 .412-.339.602-.596.691-.21.067-.373.156-.373.357 0 .377.723.745.723 1.804Zm-.232 5.595A1.971 1.971 0 0 0 10 11.165a1.971 1.971 0 0 0-2.008 1.995c0 1.092.852 1.995 2.008 1.995a1.979 1.979 0 0 0 2.008-1.995Zm-.69-5.618c0-.701-.595-1.281-1.319-1.281-.723 0-1.319.58-1.319 1.281 0 .702.596 1.282 1.319 1.282.724 0 1.32-.58 1.32-1.282Z"
        fill="#fff"
      />
    </>
  ),
  size: 20,
};

export const serviceGreenhouseDisabledTemp = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#AFB8BF" />
      <path
        d="M12.241 7.565c0 .58-.256 1.092-.676 1.493-.468.446-1.145.557-1.145.936 0 .513.864.356 1.693 1.148.549.524.887 1.215.887 2.017C13 14.74 11.67 16 10 16s-3-1.258-3-2.84c0-.803.339-1.494.887-2.017.829-.792 1.693-.635 1.693-1.148 0-.379-.677-.49-1.144-.936-.42-.401-.677-.914-.677-1.516 0-1.158.992-2.094 2.206-2.094.234 0 .444.033.619.033.315 0 .479-.133.479-.345 0-.123-.06-.279-.06-.446 0-.379.34-.691.748-.691.409 0 .736.323.736.713 0 .412-.339.602-.596.691-.21.067-.373.156-.373.357 0 .377.723.745.723 1.804Zm-.232 5.595A1.971 1.971 0 0 0 10 11.165a1.971 1.971 0 0 0-2.008 1.995c0 1.092.852 1.995 2.008 1.995a1.979 1.979 0 0 0 2.008-1.995Zm-.69-5.618c0-.701-.595-1.281-1.319-1.281-.723 0-1.319.58-1.319 1.281 0 .702.596 1.282 1.319 1.282.724 0 1.32-.58 1.32-1.282Z"
        fill="#fff"
      />
      <path
        d="M10 15a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z"
        fill="#FF6B27"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M15 16.2a.6.6 0 1 1 0 1.2.6.6 0 0 1 0-1.2Zm0-.6a.45.45 0 0 1-.45-.45v-2.1a.45.45 0 0 1 .9 0v2.1a.45.45 0 0 1-.45.45Z"
        fill="#fff"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </>
  ),
  size: 20,
};

export const serviceGreenhouseNotConnected = {
  data: (
    <>
      <path
        d="m6.153 18.996.015-1.5c.364.004.77.004 1.232.004h1.517V19H7.4c-.46 0-.874 0-1.247-.004ZM4.248 17.36c.094.021.204.04.334.058l-.01.01-.196 1.476a3.871 3.871 0 0 1-1.02-.26 4 4 0 0 1-1.996-1.99l-.004-.01a3.871 3.871 0 0 1-.26-1.02l1.477-.197.01-.01c.017.134.037.246.059.341.039.168.084.285.13.377a2.5 2.5 0 0 0 1.093 1.092c.093.048.211.093.383.133Zm-3.244-3.513 1.5-.015c-.004-.364-.004-.77-.004-1.232v-1.517H1V12.6c0 .46 0 .874.004 1.247ZM1 8.917h1.5V7.4c0-.463 0-.868.004-1.232l-1.5-.015C1 6.526 1 6.94 1 7.4v1.517Zm.096-4.54 1.477.196.01.01c.017-.134.037-.246.059-.341.039-.168.084-.285.13-.377a2.5 2.5 0 0 1 1.093-1.093c.092-.046.209-.091.377-.13.095-.022.207-.042.34-.06l-.01-.01-.196-1.476a3.872 3.872 0 0 0-1.02.26 4 4 0 0 0-1.996 1.99l-.004.01a3.872 3.872 0 0 0-.26 1.02Zm5.057-3.373C6.526 1 6.94 1 7.4 1h1.517v1.5H7.4c-.463 0-.868 0-1.232.004l-.015-1.5ZM11.083 1v1.5H12.6c.463 0 .868 0 1.232.004l.015-1.5C13.474 1 13.06 1 12.6 1h-1.517Zm4.675 1.642a3.602 3.602 0 0 0-.34-.06l.01-.01.196-1.476c.395.053.725.134 1.02.26a4.004 4.004 0 0 1 1.996 1.99l.004.01c.126.295.207.625.26 1.02l-1.477.197-.01.01a3.597 3.597 0 0 0-.057-.335 1.622 1.622 0 0 0-.133-.383 2.5 2.5 0 0 0-1.092-1.093 1.614 1.614 0 0 0-.377-.13Zm3.238 3.511-1.5.015c.004.364.004.77.004 1.232v1.517H19V7.4c0-.46 0-.874-.004-1.247Zm.004 4.93h-1.5V12.6c0 .463 0 .868-.004 1.232l1.5.015C19 13.474 19 13.06 19 12.6v-1.517Zm-.096 4.54-1.477-.196-.01-.01c-.016.131-.036.241-.057.335-.04.171-.085.29-.133.383a2.498 2.498 0 0 1-1.092 1.092 1.623 1.623 0 0 1-.383.133 3.594 3.594 0 0 1-.334.058l.01.01.196 1.476a3.87 3.87 0 0 0 1.02-.26 4.005 4.005 0 0 0 1.92-1.828c.027-.053.052-.107.076-.162l.004-.01a3.87 3.87 0 0 0 .26-1.02Zm-5.057 3.373-.015-1.5c-.364.004-.77.004-1.232.004h-1.517V19H12.6c.46 0 .874 0 1.247-.004Zm-2.282-9.938c.42-.401.676-.914.676-1.493 0-.663-.283-1.055-.495-1.348-.127-.175-.228-.315-.228-.456 0-.201.163-.29.373-.357.257-.09.596-.279.596-.69A.726.726 0 0 0 11.75 4c-.409 0-.747.312-.747.691 0 .09.017.177.033.257.013.068.026.132.026.189 0 .212-.164.345-.479.345-.081 0-.17-.007-.265-.015a4.3 4.3 0 0 0-.354-.018c-1.214 0-2.206.936-2.206 2.094 0 .602.257 1.115.677 1.516.192.183.42.31.622.422.287.16.522.291.522.514 0 .262-.226.35-.557.478-.317.122-.73.283-1.136.67C7.34 11.666 7 12.357 7 13.16 7 14.742 8.33 16 10 16s3-1.26 3-2.841c0-.803-.338-1.494-.887-2.018-.405-.386-.82-.547-1.136-.67-.331-.128-.557-.215-.557-.477 0-.223.235-.353.523-.514.201-.112.43-.238.622-.422ZM10 11.165c1.156 0 2.008.892 2.008 1.995 0 1.09-.853 1.995-2.008 1.995a1.978 1.978 0 0 1-2.008-1.995c0-1.103.852-1.995 2.008-1.995ZM10 6.261c.724 0 1.32.58 1.32 1.281 0 .702-.596 1.282-1.32 1.282-.723 0-1.319-.58-1.319-1.282 0-.701.596-1.281 1.319-1.281Z"
        fill="#008561"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </>
  ),
  size: 20,
};

export const serviceGuide = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#1F1440" />
      <path
        d="M7.942 11.74a.968.968 0 0 1 1.697.931l-1.55 2.826a.968.968 0 0 1-1.696-.93l1.549-2.826Zm5.666-6.307a.968.968 0 0 0-1.697-.93l-1.55 2.826a.968.968 0 1 0 1.697.93l1.55-2.826Z"
        fill="#FF7227"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M14.567 13.608a.968.968 0 1 0 .93-1.697l-2.826-1.55a.968.968 0 0 0-.93 1.697l2.826 1.55ZM4.503 8.09a.968.968 0 1 1 .93-1.697l2.826 1.55a.968.968 0 1 1-.93 1.696L4.503 8.09Z"
        fill="#FF2E57"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M7.344 5.735a1.355 1.355 0 1 1 2.601-.76 1.355 1.355 0 0 1-2.6.76Zm2.71 9.29a1.355 1.355 0 1 1 2.602-.76 1.355 1.355 0 0 1-2.601.76Z"
        fill="#38E4FF"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M14.265 7.345a1.355 1.355 0 1 1 .76 2.6 1.355 1.355 0 0 1-.76-2.6Zm-9.29 2.71a1.355 1.355 0 1 1 .76 2.601 1.355 1.355 0 0 1-.76-2.601Z"
        fill="#7348FF"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </>
  ),
  size: 20,
};

export const serviceLever = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#262834" />
      <g clipPath="url(#a)">
        <path
          d="m15.887 15.369-2.259-2.26a.382.382 0 0 0-.534 0l-2.26 2.26a.366.366 0 0 0 .268.631h4.518a.369.369 0 0 0 .267-.631Z"
          fill="#C3C6CC"
        />
        <path
          d="m15.963 7.254-.708-2.101a.739.739 0 0 0-.15-.257L4.085 15.914c.066.058.15.09.237.086h3.13a.664.664 0 0 0 .471-.193l7.89-7.889a.634.634 0 0 0 .15-.664Z"
          fill="#E1E3E6"
        />
        <path
          d="m14.848 4.745-2.101-.707a.633.633 0 0 0-.665.15l-7.89 7.889a.668.668 0 0 0-.192.471v3.13a.338.338 0 0 0 .086.236l11.02-11.019a.744.744 0 0 0-.258-.15Z"
          fill="#C3C6CC"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(4 4)" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </>
  ),
  size: 20,
};

export const serviceLinkedin = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#2867B2" />
      <path
        d="M6 6.5A1.25 1.25 0 1 0 6 4a1.25 1.25 0 0 0 0 2.5Zm-1 .75v7.334h2V7.25H5Zm8 7.334h2v-4.506c0-3.502-3.736-3.375-4.667-1.651V7.25h-2v7.334h2v-3.736c0-2.076 2.667-2.246 2.667 0v3.736Z"
        fill="#fff"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </>
  ),
  size: 20,
};

export const serviceLocation = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#CCE1FF" />
      <path fill="#7A8994" d="M9 8h2v8H9z" />
      <circle cx="10.1" cy="7" r="3.5" fill="#FF2E57" />
    </>
  ),
  size: 20,
};

export const serviceLogoOffice365 = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#fff" />
      <path
        d="M4 14.293v-8.51L11.529 3l4.091 1.309v11.457L11.53 17 4 14.293l7.529.907V5.292l-4.91 1.145v6.711L4 14.293Z"
        fill="#EB3C00"
      />
    </>
  ),
  size: 20,
};

export const servicePhone = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#00B07B" />
      <path
        d="M15 12.487v1.505a1.002 1.002 0 0 1-1.096 1.004 9.963 9.963 0 0 1-4.34-1.54 9.795 9.795 0 0 1-3.016-3.011 9.918 9.918 0 0 1-1.544-4.351 1.002 1.002 0 0 1 1-1.094h1.509a1.007 1.007 0 0 1 1.006.863c.063.482.181.955.352 1.41a1.002 1.002 0 0 1-.227 1.059l-.638.637a8.036 8.036 0 0 0 3.017 3.011l.638-.637a1.006 1.006 0 0 1 1.061-.226c.456.17.93.288 1.413.351A1.006 1.006 0 0 1 15 12.487Z"
        fill="#fff"
      />
    </>
  ),
  size: 20,
};

export const serviceTwitter = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#1DA1F2" />
      <path
        d="M16.305 6.184a5.04 5.04 0 0 1-1.45.397 2.528 2.528 0 0 0 1.11-1.396c-.487.289-1.028.499-1.603.612A2.527 2.527 0 0 0 10.06 8.1a7.167 7.167 0 0 1-5.203-2.637 2.528 2.528 0 0 0 .78 3.37 2.514 2.514 0 0 1-1.142-.315 2.526 2.526 0 0 0 2.024 2.507 2.531 2.531 0 0 1-1.14.043 2.526 2.526 0 0 0 2.359 1.753A5.076 5.076 0 0 1 4 13.866 7.147 7.147 0 0 0 7.87 15c4.687 0 7.335-3.959 7.175-7.51a5.14 5.14 0 0 0 1.26-1.306Z"
        fill="#fff"
      />
    </>
  ),
  size: 20,
};

export const serviceYoutube = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#FC0D1B" />
      <path d="M8 7v6l5-3-5-3Z" fill="#fff" />
    </>
  ),
  size: 20,
};

export const serviceZoom = {
  data: (
    <>
      <rect x="1" y="1" width="18" height="18" rx="4" fill="#2D8CFF" />
      <path
        d="M10 7H5v4a2 2 0 0 0 2 2h5V9a2 2 0 0 0-2-2Zm5 0v6l-2-1.5v-3L15 7Z"
        fill="#fff"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </>
  ),
  size: 20,
};
